import { ContentContainer, useDebouncedSearch } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { AssetFiltersBar } from '../../assets/AssetFiltersBar';
import { AssetList } from '../../assets/AssetList';
import DeviceCarrierProvider from '../../providers/DeviceCarrierProvider';

export function AssetsPage() {
  const { search, setSearch, trigger: debouncedSearch } = useDebouncedSearch('');
  const [reloadPage, setReloadPage] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState<string>();
  const [selectedSubClientId, setSelectedSubClientId] = useState<string>();
  const [monitoring, setMonitoring] = useState<boolean | undefined>();

  return (
    <ContentContainer>
      <DeviceCarrierProvider />
      <AssetFiltersBar
        monitoring={monitoring}
        onChangeSearch={setSearch}
        onReloadPage={() => setReloadPage(!reloadPage)}
        search={search}
        selectedClientId={selectedClientId}
        selectedSubClientId={selectedSubClientId}
        setMonitoring={setMonitoring}
        setSelectedClientId={setSelectedClientId}
        setSelectedSubClientId={setSelectedSubClientId}
      />
      <AssetList
        search={debouncedSearch}
        reloadPage={reloadPage}
        selectedClientId={selectedClientId}
        selectedSubClientId={selectedSubClientId}
        monitoring={monitoring}
      />
    </ContentContainer>
  );
}
